import MoreInfoModal from './MoreInfoModal'

export default MoreInfoModal
